import { z } from "zod";
import { ReadChartsItemSchema } from "../readExcel/readExcel.schema";
export const ReadChartsParamsSchema = z.object({
    readCharts: z
        .array(ReadChartsItemSchema)
        .describe("Read authoritative chart payloads (chartXml/readId/version)."),
    sessionId: z.string().optional().describe("Backend session ID (injected automatically)"),
});
export { ReadChartsParamsSchema as ReadChartsToolParamsSchema };
